const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/matomo.ts';
import { getConfiguration } from './clientSetupGetRessource';
import { VERSION, VERSION_SUB } from 'App/defs/defs';
import { TrackingState } from 'App/defs/trackingDefs';
import { getMainConfigClient } from '@cistec/common_web/services/mainConfig';
import * as matamo from '@datapunt/matomo-tracker-react';
import { trackingSelector } from 'App/store/tracking';

const { customMatomoClientId } = getConfiguration();
const appClient = getMainConfigClient();

if (appClient !== 'com' && customMatomoClientId === 1) {
    throw new Error(
        `The matomoClientId cannot be 1 if mandator is ${appClient.toUpperCase()} because 1 is for COM. Please setup a new instance on the matomo websites`
    );
}

export const isMatomoEnabled = !!customMatomoClientId;
const urlBase: string =
    process.env.NODE_ENV !== 'production'
        ? 'https://mobiledev.cistec.com/misc/matomo/'
        : 'https://cistec.matomo.cloud/';

function getMatomoInstance() {
    return matamo.createInstance({
        urlBase: urlBase,
        siteId: customMatomoClientId!,
        userId: undefined, // optional, default value: `undefined`.
        trackerUrl: `${urlBase}matomo.php`, // optional, default value: `${urlBase}matomo.php`
        srcUrl: `${urlBase}matomo.js`, // optional, default value: `${urlBase}matomo.js`
        disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
        heartBeat: {
            // optional, enabled by default
            active: true, // optional, default value: true
            seconds: 15, // optional, default value: `15
        },
        linkTracking: false, // optional, default value: true
        configurations: {
            // optional, default value: {}
            // any valid matomo configuration, all below are optional
            disableCookies: true,
            setSecureCookie: true,
            setRequestMethod: 'POST',
        },
    });
}

const getTruncatePatNr = (action: any) => {
    return action.meta?.patnr?.substring(10, 40) || action.payload?.kisim?.patnr?.substring(10, 40) || '_NULL_';
};

export function matomoHandler(state: any) {
    if (isMatomoEnabled) {
        const matomoInstanceInternal = getMatomoInstance();
        const matomoTrackOwnEvent = (category: string, action: string) => {
            matomoInstanceInternal.trackEvent({
                category,
                action,
                customDimensions: [
                    {
                        id: 1,
                        value: `${VERSION + '' + VERSION_SUB}`,
                    },
                ],
            });
        };
        return (next: any) => (action: any) => {
            const isTrackingAllowed = (trackingSelector(state?.getState()) as any) === TrackingState.AGREE;
            if (!isTrackingAllowed) {
                return next(action);
            }
            const rdxEventMsg = `redux event: ${action.type}`;
            switch (action.type) {
                case '@@router/LOCATION_CHANGE':
                    matomoTrackOwnEvent('LOCATION_CHANGE', `${action.payload?.location?.pathname}`);
                    break;
                case 'PATAPP_GET_TOKEN_FROM_SMSCODE_SUCCESS':
                case 'PATAPP_GET_TOKEN_FOR_TEST_PATIENT_SUCCESS':
                    matomoInstanceInternal.pushInstruction('setUserId', getTruncatePatNr(action));
                    matomoTrackOwnEvent('LOGIN', rdxEventMsg);

                    break;
                case 'PATAPP_GET_REGISTER_WORKITEM_SUCCESS':
                    matomoInstanceInternal.pushInstruction('setUserId', action?.payload?.kisim?.userDetails?.sub);
                    matomoTrackOwnEvent('LOGIN', rdxEventMsg);
                    break;
                case 'PATAPP_FINALIZE_ECHECKIN_SUCCESS':
                    matomoTrackOwnEvent('ECHECKIN_SUCCESS', rdxEventMsg);
                    break;
                case 'SCHEDULE_LOG':
                    matomoTrackOwnEvent(
                        'LOG',
                        `${rdxEventMsg}, log: ${JSON.stringify(action?.payload).substring(0, 200)}`
                    );
                    break;
                default:
                    if (action?.type?.endsWith('FAILURE') || action?.type?.endsWith('FAILED')) {
                        matomoTrackOwnEvent('FAILURE', rdxEventMsg);
                    }
            }
            return next(action);
        };
    }
    return (next: any) => (action: any) => next(action);
}
